import { cn } from '@folio/lib';
import { InformationFieldCell } from './InformationFieldCell';

export const InformationFieldLabel = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <InformationFieldCell className={cn('font-semibold text-left', className)}>
      {children}
    </InformationFieldCell>
  );
};
